// Imports principaux
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faFileImport } from '@fortawesome/free-solid-svg-icons';

// Import Layout
import PageHeader from 'layout/PageHeader';

// Composants Legacy
import LegacyFournisseursTable from '../legacy/components/LegacyFournisseursTable';
import LegacyClientsTable from '../legacy/components/LegacyClientsTable';
import LegacyCommandesTable from '../legacy/components/LegacyCommandesTable';

// Définition des onglets
const tabs = [
	{ key: 'fournisseurs', label: 'Fournisseurs' },
	{ key: 'clients', label: 'Clients' },
	{ key: 'commandes', label: 'Commandes' },
];

// Composant principal de la page d'import
const ImportPage: React.FC = () => {
	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState('fournisseurs');

	const token = localStorage.getItem('token') || '';

	const renderTabContent = () => {
		switch (activeTab) {
			case 'fournisseurs':
				return <LegacyFournisseursTable token={token} />;
			case 'clients':
				return <LegacyClientsTable token={token} />;
			case 'commandes':
				return <LegacyCommandesTable token={token} />;
			default:
				return null;
		}
	};

	return (
		<div className="min-h-screen bg-gray-100 p-6">
			<PageHeader
				icon={faFileImport}
				title="Importation de données"
				subtitle="Importez vos données depuis les sources legacy"
			/>
			<div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6 mt-8">
				{/* Onglets */}
				<div className="mt-8 border-b border-gray-300">
					<nav className="-mb-px flex space-x-4">
						{tabs.map((tab) => (
							<button
								key={tab.key}
								className={`px-4 py-2 font-medium ${
									activeTab === tab.key
										? 'border-b-2 border-blue-500 text-blue-600'
										: 'text-gray-500 hover:text-gray-700'
								}`}
								onClick={() => setActiveTab(tab.key)}
							>
								{tab.label}
							</button>
						))}
					</nav>
				</div>

				{/* Contenu onglet */}
				<div className="mt-6">{renderTabContent()}</div>

				{/* Bouton retour */}
				<div className="mt-6 flex justify-end">
					<button
						onClick={() => navigate('/app/settings')}
						className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition"
					>
						<FontAwesomeIcon icon={faAngleLeft} />
						Retour
					</button>
				</div>
			</div>
		</div>
	);
};

export default ImportPage;
